import type { CSSProperties, ReactElement } from "react";
import { CareersLanguageProvider } from "../../_components/careers-language-context";
import { CareersProductMockup } from "../../_components/careers-product-mockup";
import "../../_components/careers.css";
import type { FunnelSection } from "./developers-funnel-content";
import { FunnelIcon } from "./developers-funnel-icons";

/** Same 1300px card + mockup column as /careers/en, solid white (no mint fade). */
const CARD: CSSProperties = {
  position: "relative",
  borderRadius: 30,
  background: "#ffffff",
  border: "1px solid rgba(11,15,25,0.10)",
  boxShadow:
    "0 44px 84px -52px rgba(10,15,25,0.34), 0 10px 26px -18px rgba(10,15,25,0.10)",
  padding: "clamp(34px,4vw,64px) clamp(28px,4vw,62px)",
  overflow: "hidden",
};

const GRID: CSSProperties = {
  position: "relative",
  zIndex: 1,
  display: "grid",
  gridTemplateColumns: "1.42fr 0.75fr",
  gap: "clamp(30px,3.5vw,60px)",
  alignItems: "center",
};

/**
 * First developers section: 1300px white card + mockup column.
 * Mockup is a direct grid child so `careers-mockup-bleed` can overflow into the card.
 */
export function DevelopersWorkSection({
  section,
}: {
  readonly section: FunnelSection;
}): ReactElement {
  return (
    <CareersLanguageProvider initialLang="en">
      <section id={section.id} className="dvf-section dvf-section-work">
        <div className="dvf-work-stage">
          <div className="careers-about-card" style={CARD}>
            <div className="careers-grid-2col" style={GRID}>
              <CareersProductMockup />
              <div className="dvf-work-copy">
                <h2 className="dvf-section-title" style={{ color: "#0a0f19" }}>
                  {section.heading}
                </h2>
                {section.intro ? (
                  <p className="dvf-section-intro" style={{ color: "#4a545e" }}>
                    {section.intro}
                  </p>
                ) : null}
                <ul className="dvf-bullets">
                  {section.bullets.map((bullet) => (
                    <li className="dvf-bullet" key={bullet.title}>
                      <span className="dvf-bullet-icon">
                        <FunnelIcon name={bullet.icon} size={20} />
                      </span>
                      <div>
                        <p
                          className="dvf-bullet-title"
                          style={{ color: "#0a0f19" }}
                        >
                          {bullet.title}
                        </p>
                        <p
                          className="dvf-bullet-text"
                          style={{ color: "#4a545e" }}
                        >
                          {bullet.text}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </CareersLanguageProvider>
  );
}
